import { render } from "./DenaturantBulkRegistry.vue?vue&type=template&id=5faba456&scoped=true"
import script from "./DenaturantBulkRegistry.vue?vue&type=script&lang=js"
export * from "./DenaturantBulkRegistry.vue?vue&type=script&lang=js"

import "./DenaturantBulkRegistry.vue?vue&type=style&index=0&id=5faba456&lang=css&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5faba456"]])

export default __exports__